const slugify = (text = "") =>
  text
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, "et")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-");
export const cardData = [
  {
    title: "maison & déco",
    slug: slugify("maison & déco"),
    sousFamille: [
      {
        nom: "luminaire",
        slug: slugify("luminaire"),
        iconName: "LightOutlinedIcon",
        sousFamilles: [
          { nom: "suspensions luminaires", slug: slugify("suspensions luminaires"), sousSousFamilles: [] },
          { nom: "plafonniers et lampes plafond", slug: slugify("plafonniers et lampes plafond"), sousSousFamilles: [] },
          { nom: "lampes de table", slug: slugify("lampes de table"), sousSousFamilles: [] },
          { nom: "spots", slug: slugify("spots"), sousSousFamilles: [] },
          { nom: "ampoules", slug: slugify("ampoules"), sousSousFamilles: [] },
          { nom: "spots encastrables", slug: slugify("spots encastrables"), sousSousFamilles: [] },
        ],
      },
      {
        nom: "meubles",
        slug: slugify("meubles"),
        iconName: "TableRestaurantOutlinedIcon",
        sousFamilles: [],
      },
    ],
  },

  {
    title: "électroménager & cuisine",
    slug: slugify("électroménager & cuisine"),
    sousFamille: [
      {
        nom: "cuisine",
        slug: slugify("cuisine"),
        iconName: "BlenderOutlinedIcon",
        sousFamilles: [
          { nom: "preparation culinaire", slug: slugify("preparation culinaire"), sousSousFamilles: [] },
          { nom: "appareil de cuisson", slug: slugify("appareil de cuisson"), sousSousFamilles: [] },
          { nom: "cafe et petit dejeuner", slug: slugify("cafe et petit dejeuner"), sousSousFamilles: [] },
        ],
      },
      {
        nom: "maison",
        slug: slugify("maison"),
        iconName: "CottageOutlinedIcon",
        sousFamilles: [],
      },
    ],
  },

  {
    title: "informatique & lifestyle",
    slug: slugify("informatique & lifestyle"),
    sousFamille: [
      {
        nom: "informatique",
        slug: slugify("informatique"),
        iconName: "LaptopMacOutlinedIcon",
        sousFamilles: [
          { nom: "souris", slug: slugify("souris"), sousSousFamilles: [] },
          { nom: "casque", slug: slugify("casque"), sousSousFamilles: [] },
          { nom: "enceinte & radio reveil", slug: slugify("enceinte & radio reveil"), sousSousFamilles: [] },
          { nom: "accessoire", slug: slugify("accessoire"), sousSousFamilles: [] },
          { nom: "cable", slug: slugify("cable"), sousSousFamilles: [] },
          { nom: "cle usb", slug: slugify("cle usb"), sousSousFamilles: [] },
          { nom: "lecteur de carte et micro sd", slug: slugify("lecteur de carte et micro sd"), sousSousFamilles: [] },
        ],
      },
      {
        nom: "lifestyle",
        slug: slugify("lifestyle"),
        iconName: "WatchOutlinedIcon",
        sousFamilles: [
          {
            nom: "accessoires",
            slug: slugify("accessoires lifestyle"),
            sousSousFamilles: [
              { nom: "enfant", slug: slugify("enfant") },
              { nom: "homme", slug: slugify("homme") },
              { nom: "femme", slug: slugify("femme") },
            ],
          },
          {
            nom: "beaute & sante",
            slug: slugify("beaute & sante"),
            sousSousFamilles: [
              { nom: "bien etre", slug: slugify("bien etre") },
              { nom: "coiffure", slug: slugify("coiffure") },
              { nom: "epilation", slug: slugify("epilation") },
              { nom: "rasoir et tondeuse", slug: slugify("rasoir et tondeuse") },
              { nom: "soin visage et corps", slug: slugify("soin visage et corps") },
              { nom: "maternite", slug: slugify("maternite") },
              { nom: "orthopedie", slug: slugify("orthopedie") },
            ],
          },
        ],
      },
    ],
  },

 {
  title: "tout à 100 dt",
  slug: slugify("tout à 100 dt"),
  redirectTo: "tout-a-100-dt",
  sousFamille: []
}
];